<template>
    <b-modal
        :visible="isModalVisible"
        :centered="centered"
        :size="modalSize"
        :no-close-on-backdrop="true"
        hide-header-close
        :scrollable="scrollable"
        :modal-class="showOverLay ? 'active-overlay' : ''"
        :body-class="scrollable ? 'modal-body-scrollable' : ''"
    >
        <template #modal-header>
            <h5 class="modal-title">
                {{ showOverLay ? 'Thông báo' : modalTitle }}
            </h5>

            <b-icon
                @click="openOverLay"
                icon=" x-lg"
                aria-hidden="true"
                class="icon-close"
            >
            </b-icon>
        </template>
        <template #default>
            <template v-if="!showOverLay">
                <slot name="content"></slot>
            </template>

            <b-overlay
                :show="showOverLay"
                no-wrap
                @shown="onShown"
                @hidden="onHidden"
                opacity="1"
            >
                <template #overlay>
                    <div
                        ref="dialog"
                        tabindex="-1"
                        role="dialog"
                        aria-modal="false"
                        aria-labelledby="form-confirm-label"
                    >
                        Các thông tin vừa nhập sẽ bị mất khi đóng trang. Thầy cô
                        có muốn tiếp tục chỉnh sửa, kiểm tra và lưu lại thông tin
                        đã nhập?
                    </div>
                </template>
            </b-overlay>
        </template>

        <template #modal-footer>
            <span v-if="showOverLay === false">
                <CustomButton label="Đóng" @click="openOverLay" :plain="true" />
                <slot name="btn-handle"></slot>
            </span>
            <span v-else>
                <CustomButton
                    :plain="true"
                    label="Tiếp tục chỉnh sửa"
                    @click="closeOverLay"
                />
                <CustomButton
                    style="background-color: var(--blue-200)"
                    label="Rời khỏi trang"
                    @click="closeModalHandler"
                />
            </span>
        </template>
    </b-modal>
</template>

<script>
import CustomButton from './CustomButton.vue'
export default {
    components: { CustomButton },
    props: {
        isModalVisible: {
            type: Boolean,
            required: true
        },
        modalTitle: {
            type: String,
            default: ''
        },
        closeFunction: {
            type: Function,
            default: () => {}
        },
        centered: {
            type: Boolean,
            default: true
        },
        size: {
            type: String
        },
        errModal: { type: Boolean },
        scrollable: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            showOverLay: false,
            interval: null
        }
    },
    beforeDestroy() {
        this.clearInterval()
    },
    methods: {
        openOverLay() {
            if (this.errModal === true) {
                this.showOverLay = true
            } else {
                this.closeModalHandler()
                this.showOverLay = false
            }
        },
        closeOverLay() {
            this.showOverLay = false
        },
        closeModalHandler() {
            this.closeOverLay()
            this.closeFunction()
            this.$emit('hidden')
        },
        clearInterval() {
            if (this.interval) {
                clearInterval(this.interval)
                this.interval = null
            }
        },
        onShown() {
            if (this.$refs.dialog) {
                this.$refs.dialog.focus()
            }
        },
        onHidden() {
            const submitRef = this.$refs.submit
            if (submitRef && submitRef.$el) {
                submitRef.$el.focus()
            }
        }
    },
    computed: {
        modalSize() {
            return this.showOverLay ? 'lg' : this.size
        }
    }
}
</script>

<style scoped>
::v-deep .modal-header {
    align-items: center !important;
    background-color: var(--bg-btn-close-modal);
    color: white;
}

.icon-close {
    cursor: pointer;
}

.icon-close:hover {
    color: #9abddf;
}

/* Allow poppers (body-appended) to show above modal and avoid clipping */
::v-deep .modal-dialog,
::v-deep .modal-content {
    /* allow dropdowns to overflow the modal boundaries (so poppers can escape) */
    overflow: visible !important;
}

/* Ensure element-ui poppers get a safe z-index above bootstrap modal/backdrop */
::v-deep .el-popper,
::v-deep .el-select-dropdown,
::v-deep .el-select-dropdown__wrap,
::v-deep .el-select-dropdown__list {
    z-index: 2050 !important;
}

/* In case of inline render (append-to-body=false), make dropdown width stretch to container */
::v-deep .select-wrapper .el-select-dropdown {
    width: 100% !important;
    min-width: 100% !important;
    box-sizing: border-box !important;
}

/* Improved scrollable modal body */
::v-deep .modal-body-scrollable {
    max-height: 60vh;
    overflow-y: auto;
    padding: 15px 20px;
}

/* Better scrollbar styling */
::v-deep .modal-body-scrollable::-webkit-scrollbar {
    width: 8px;
}

::v-deep .modal-body-scrollable::-webkit-scrollbar-track {
    background: #f1f1f1;
    border-radius: 4px;
}

::v-deep .modal-body-scrollable::-webkit-scrollbar-thumb {
    background: #c1c1c1;
    border-radius: 4px;
}

::v-deep .modal-body-scrollable::-webkit-scrollbar-thumb:hover {
    background: #a8a8a8;
}

/* Expand XL modal to be wider for better content display */
::v-deep .modal-xl {
    max-width: 90% !important;
}

::v-deep .modal-xl .modal-dialog {
    max-width: 90% !important;
}

@media (min-width: 1200px) {
    ::v-deep .modal-xl {
        max-width: 85% !important;
    }

    ::v-deep .modal-xl .modal-dialog {
        max-width: 85% !important;
    }
}

@media (min-width: 1400px) {
    ::v-deep .modal-xl {
        max-width: 80% !important;
    }

    ::v-deep .modal-xl .modal-dialog {
        max-width: 80% !important;
    }
}

@media (min-width: 1600px) {
    ::v-deep .modal-xl {
        max-width: 75% !important;
    }

    ::v-deep .modal-xl .modal-dialog {
        max-width: 75% !important;
    }
}
</style>
